module.exports = __webpack_public_path__ + "img/dialog_corner.6890a232.svg";